module.exports = __webpack_public_path__ + "664ee6786b6e728c7e6a47039805ef85.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/food/food7.png
// module id = 2459
// module chunks = 0